module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine platform - a white-label healthcare operating system.04efee64.jpg";